const LineItemApiUrls = {
  GET: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/sbci-invoice/line-item/get`,
  POST: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/sbci-invoice/line-item/create`,
  PUT: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/sbci-invoice/line-item/update`,
  DELETE: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/sbci-invoice/line-item/delete`,
  EXPORT: `${process.env.REACT_APP_USER_SBCI_URL}/sbci/sbci-invoice/line-item/download`
}

export default LineItemApiUrls
